import { Stack } from '@chakra-ui/react';
import { FolderIcon, HomeIcon, IdentificationIcon } from '@heroicons/react/outline';
import { useLocation } from 'react-router-dom';
import { useTranslations } from 'use-intl';

import { routes } from '@blockpulse3/data/shared';
import { NavGroupItem } from '@blockpulse3/ui/commons';

type Props = unknown;

export function SettingsNavUser(): JSX.Element {
  const i18nSidebar = useTranslations('Sidebar');

  const { pathname } = useLocation();

  const homeRoute = routes.me.href;
  const settingsRoute = routes.me.settings.href;
  const documentsRoute = routes.me.documents.full;

  return (
    <Stack spacing="1">
      <NavGroupItem
        active={pathname === homeRoute}
        href={homeRoute}
        icon={<HomeIcon height="18" width="18" />}
        label={i18nSidebar('HomeTitle')}
      />
      <NavGroupItem
        active={pathname === documentsRoute}
        href={documentsRoute}
        icon={<FolderIcon height="18" width="18" />}
        label={i18nSidebar('DocumentsTitle')}
      />
      <NavGroupItem
        active={pathname === settingsRoute}
        href={settingsRoute}
        icon={<IdentificationIcon height="18" width="18" />}
        label={i18nSidebar('SettingsIndividual')}
      />
    </Stack>
  );
}

export type SettingsNavUserProps = Props;
